import React from 'react';

const Contact = () => {
  return (
    <section className="py-20 px-4 bg-white text-center">
      <h2 className="text-3xl md:text-4xl font-bold text-[#003366] mb-10">Contact Us</h2>

      <div className="max-w-5xl mx-auto grid md:grid-cols-2 gap-10 text-left">
        {/* Formulario */}
        <div>
          <form className="space-y-4">
            <div>
              <label className="block text-gray-700 mb-1">Name</label>
              <input type="text" className="w-full border border-gray-300 p-3 rounded-md" placeholder="Your name" />
            </div>
            <div>
              <label className="block text-gray-700 mb-1">Email</label>
              <input type="email" className="w-full border border-gray-300 p-3 rounded-md" placeholder="you@example.com" />
            </div>
            <div>
              <label className="block text-gray-700 mb-1">Message</label>
              <textarea className="w-full border border-gray-300 p-3 rounded-md h-32" placeholder="How can we help you?"></textarea>
            </div>
            <button type="submit" className="bg-[#003366] text-white px-6 py-3 rounded-full hover:bg-blue-800 transition">
              Send Message
            </button>
          </form>
        </div>

        {/* Datos de contacto */}
        <div className="text-gray-700 space-y-4">
          <p><strong>Address:</strong> 4227 S Meridian STE D, Puyallup, WA, 98373</p>
          <p><strong>Phone:</strong> 253-368-4114</p>
          <p><strong>Email:</strong> info@cjhtransportation.com</p>
        </div>
      </div>

      {/* Mapa */}
      <div className="w-full max-w-5xl mx-auto h-72 md:h-96 mt-10 rounded-xl overflow-hidden shadow-md">
        <iframe
          title="CJH Transportation Location"
          src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2713.3317423379153!2d-122.29488952382171!3d47.15135681930367!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x5490fc5756b47251%3A0x4c27eb7758407bc1!2s4227%20S%20Meridian%2C%20Puyallup%2C%20WA%2098373!5e0!3m2!1ses-419!2sus!4v1748910358572!5m2!1ses-419!2sus"
          width="100%"
          height="100%"
          style={{ border: 0 }}
          allowFullScreen=""
          loading="lazy"
          referrerPolicy="no-referrer-when-downgrade"
        ></iframe>
      </div>
    </section>
  );
};

export default Contact;
